// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__K3hYb","navbar__links":"NavBar_navbar__links__KnUng"};